import App from './omraadetittel.svelte'

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export default function hydrate(el, props) {
  return new App({
    target: el,
    hydrate: true,
    props,
  })
}
